@if (selectedContainers | async; as selection$) {
  <div class="organizational-container-selector"
    (clickedOutside)="closeContainerList()"
     [ngClass]="{
       'organizational-container-selector--pure': pure,
       'organizational-container-selector--wide': wide
     }">
    @if (renderer | async; as renderer$) {
      @if (containers | async; as containers$) {
        <div
          class="organizational-container-selector__title color-muted"
        [translate]="'carrier.channel-selector.selected-channel'"></div>
        <div class="organizational-container-selector__selection"
          [ngClass]="{ 'organizational-container-selector__selection--opened': listOpened | async }"
          (click)="toggleContainerList()" (keyup.enter)="toggleContainerList()" tabindex="0">
          <organizational-container
            [container]="selection$[0]"
            [allContainers]="containers$">
            <web-component-wrapper
              [elementName]="renderer$"
              #selectedContainer
            [elementAttributes]="{
              container: selection$[0],
              containers: containers$,
              selection: selection$,
              isListItem: false
            }"></web-component-wrapper>
          </organizational-container>
          <div class="icon-wrapper">
            <hls-icon icon="arrow-chevron-down"></hls-icon>
          </div>
        </div>
        <div class="organizational-container-selector__list"
          #listContainer
           [ngClass]="{
            'organizational-container-selector__list--opened': listOpened | async,
            'organizational-container-selector__list--visible': listVisible | async
           }">
          <div class="organizational-container-selector__list__headline">
            <h2 [translate]="'carrier.channel-selector.your-channels'"></h2>
            <ng-template #selectAllContent>
              <div class="organizational-container-selector__list__select-all">
                <div>
                  <hls-icon icon="editor-list-unordered"></hls-icon>
                </div>
                <div [translate]="'carrier.channel-selector.select-all-channels'"></div>
              </div>
            </ng-template>
            @if (!selection$.length) {
              <div>
                @if (containers$.length > 1) {
                  <hls-toggle-button-group value="all">
                    <hls-toggle-button value="all" (click)="selectContainers([])">
                      <ng-container *ngTemplateOutlet="selectAllContent"></ng-container>
                    </hls-toggle-button>
                  </hls-toggle-button-group>
                }
              </div>
            }
            @if (selection$.length) {
              <div>
                @if (containers$.length > 1) {
                  <hls-toggle-button-group value="none" >
                    <hls-toggle-button value="all" (click)="selectContainers([])">
                      <ng-container *ngTemplateOutlet="selectAllContent"></ng-container>
                    </hls-toggle-button>
                  </hls-toggle-button-group>
                }
              </div>
            }
          </div>
          <div class="organizational-container-selector__list__items" #containerList>
            @for (container of containers$; track container) {
              <organizational-container
                class="organizational-container-selector__list__items__item"
                #containers
                [container]="container"
                [allContainers]="containers$"
                (click)="selectContainers([container])"
            [ngClass]="{
              'organizational-container-selector__list__items__item--selected': isSelected(selection$, container)
            }">
                <web-component-wrapper
                  [elementName]="renderer$"
                  #containerHosts
              [elementAttributes]="{
                container: container,
                containers: containers$,
                selection: selection$,
                isListItem: true
              }"></web-component-wrapper>
              </organizational-container>
            }
          </div>
        </div>
      }
    }
  </div>
}
